import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { hasPermission, resolveEffectivePermissions, RolePermissionMap } from '../utils/menu-access.util';

export const authGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (tokenStorage.isAuthenticated()) {
    console.timeLog('dlap:login-to-dashboard', 'authGuard resolved (route activated)');
    return true;
  }

  router.navigate(['/auth/login']);
  return false;
};

export const permissionGuard = (
  permission: string,
  fallbackUrl = '/overview/applications',
  permissionMatrix: readonly RolePermissionMap[] = [],
): CanActivateFn => {
  return () => {
    const tokenStorage = inject(TokenStorageService);
    const router = inject(Router);

    if (!tokenStorage.isAuthenticated()) {
      router.navigate(['/auth/login']);
      return false;
    }

    const user = tokenStorage.getUser();
    const permissions = resolveEffectivePermissions(user, permissionMatrix);
    console.log('User Permissions:', permissions);
    if (hasPermission(permissions, permission)) {
      return true;
    }

    router.navigate([fallbackUrl]);
    return false;
  };
};
